module.exports = __webpack_public_path__ + "img/approve-list16.6656d9ef.png";